import { useMemo } from 'react'
import { z } from 'zod'

import { requiredFile, requiredTrimmedString } from '../../../../../app/_components/form/zodSchemas'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { allowedLogoNameInputCharactersPattern } from '../../../../../containers/EmbroideryContainer/utils/unorganized'
import { Props as TextEmbroideryValidationSchemaProps } from '../TextEmbroideryForm/useValidationSchema'

interface Props extends TextEmbroideryValidationSchemaProps {}

export const useLogoSetupValidationSchema = ({ textMaxChars }: Props) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return z.object({
      name: requiredTrimmedString(fixtures.validationErrorMessages.requiredLogoName)
        .max(
          textMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            textMaxChars.toString()
          )
        )
        .regex(
          allowedLogoNameInputCharactersPattern,
          fixtures.validationErrorMessages.allowedTextCharacters
        ),
      notes: z.string().optional(),
      file: requiredFile(fixtures.validationErrorMessages.requiredFile),
      digitization_setting: z.enum(['BLACK_WHITE', 'COLOR'], {
        error: fixtures.validationErrorMessages.requiredDigitizationSetting,
      }),
      // The terms-of-service checkbox is modelled as an array so Ariakit's checkbox field can push
      // and pop a single value; exactly one entry means "accepted".
      tos: z
        .array(z.string(), { error: fixtures.validationErrorMessages.requiredTos })
        .min(1, fixtures.validationErrorMessages.requiredTos)
        .max(1),
    })
  }, [fixtures.validationErrorMessages, textMaxChars])

  return validationSchema
}
